
import React, { useEffect, useState } from 'react'
import NavBar from './NavBar'
import Home from './Home/Home.js'
import { Box, Container, CssBaseline, Fab, Fade, ThemeProvider, useScrollTrigger} from '@mui/material'
import Skills from './Skills/Skills.js';
import { useLocation } from 'react-router-dom';
import Resume from './Resume/Resume.js';
import About from './About/About.js';
import Contact from './Contact/Contact.js';
import theme from './Theme.js';
import Footer from './Footer/Footer.js';
import TechHighlights from './About/TechHighlights.js';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Faqs from './Faqs/Faqs.js';
import Works from './Works/Works.js';
import Cursor from './Utils/Cursor.jsx';
import ChatBot from './Utils/ChatBot.jsx';
import PortfolioLoader from './Utils/PortfolioLoader.jsx';

function ScrollTop(props) {
  const { children} = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 500,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#home',
    );

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 16, right: 16 ,zIndex:"999"}}
      >
        {children}
      </Box>
    </Fade>
  );
}

function LandingPage(props) {
  const[mainTheme,setMainTheme]=useState(theme("dark"));

  const location = useLocation();
  useEffect(() => {
    const hash = new URLSearchParams(location.search).get('section');
    if (hash) {
      const element = document.getElementById(hash);
      console.log(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  
  function changeMode(mode){
    setMainTheme(theme(mode));
}
  return (
    // <Container>
      <ThemeProvider theme={mainTheme} >
        {/* Portfolio Loader: Liquid Wave Fill Typography (set alwaysShow={true} to test on refresh; oncePerSession={true} for production) */}
        <PortfolioLoader alwaysShow={true} />
        <Cursor/>
        <ChatBot/>
        <CssBaseline />
        <Container id="home"> 
          <NavBar changeMode={changeMode}/>
           <Home />
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top"  >
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
          <About/>
         <TechHighlights/>
           <Resume/>
          <Skills/>
          <Works/>
          <Contact/>
          <Faqs/>
        </Container>
          <Footer />
      </ThemeProvider>

    // </Container>
  )
}

export default LandingPage